<div class="driver-side-list">

  <div class="ui-g-12 p-1 driver-accordion" [ngClass]="{'border-color-bottom':showForm }">
    <div class="ui-g-12 py-1 px-2 flex-between-center" (click)="toggleFormEmit()">
      <div class="flex-start">
        <div class="side-driver-name">
          <ng-container *ngIf="showForm; else showChevronRight">
            <i class="fal fa-chevron-down fa-fw accordion-icon"></i>
          </ng-container>
          <ng-template #showChevronRight>
            <i class="fal fa-chevron-right fa-fw accordion-icon"></i>
          </ng-template>
        </div>
        <div class="side-driver-name pl-3">
          <p class="font-16 font-600 m-0 capitalize">
            {{driver.fullName}}
          </p>
        </div>
      </div>
      <div class="flex-end-center ml-2" (click)="$event.stopPropagation()">
        <div (click)="$event.stopPropagation()">
          <app-switch-pill id="driver-update-isactive" [isActive]="driver.isActive"
            [label]="true ? 'Active' : 'Inactive'" position="end" [fontSize]="12"
            (appChange)="handleChange('isActive', $event)" [disabled]="!driver?._id"
            [tooltipPosition]=" 'right'"></app-switch-pill>
        </div>
      </div>
    </div>
  </div>

  <div [@accordion]="showForm ? 'expanded' : 'collapsed'" class="pl-2">
    <div class="ui-g-12 p-0">
      <!-- name -->
      <div class="ui-g-6 p-0 pr-4 mt-30">
        <div class="">
          <app-input id="driver-update-fullName" [value]="driver.fullName" name="fullName" theme="primary"
            placeholder="Name *" [fontSize]="14" [maxLength]="25" (appChange)="handleChange('fullName', $event)"
            [isInvalid]="error.fullName" [errorMessage]="error.fullName" [floatingLabel]="true"></app-input>
        </div>
      </div>
      <!-- employee-number -->
      <div class="ui-g-6 p-0 pr-4 mt-30">
        <div class="">
          <app-input id="driver-update-employee-number" [value]="driver.employeeNumber" name="employee-number"
            theme="primary" placeholder="Employee number" [fontSize]="14" [maxLength]="25"
            (appChange)="handleChange('employeeNumber', $event)" [isInvalid]="error.employeeNumber"
            [errorMessage]="error.employeeNumber" [floatingLabel]="true"></app-input>
        </div>
      </div>
    </div>
    <div class="ui-g-12 p-0">
      <!-- serviceCardNumber -->
      <div class="ui-g-6 p-0 pr-4 mt-30">
        <div class="">
          <app-input id="driver-update-service-card-number" [value]="driver.serviceCardNumber"
            name="service-card-number" theme="primary" placeholder="Service Card Number" [fontSize]="14"
            [maxLength]="25" (appChange)="handleChange('serviceCardNumber', $event)"
            [isInvalid]="error.serviceCardNumber" [errorMessage]="error.serviceCardNumber"
            [floatingLabel]="true"></app-input>
        </div>
      </div>
      <!-- City -->
      <div class="ui-g-6 p-0 pr-4 mt-30">
        <div class="">
          <app-input id="driver-update-company-name" [value]="driver.companyName" name="company-name" theme="primary"
            placeholder="Company Name" [fontSize]="14" [maxLength]="25"
            (appChange)="handleChange('companyName', $event)" [isInvalid]="error.companyName"
            [errorMessage]="error.companyName" [floatingLabel]="true"></app-input>
        </div>
      </div>
    </div>

    <div [@toggleBox]="isOpen ? 'open' : 'closed'">
      <span [hidden]="!isOpen">
        <div class="ui-g-12 p-0">
          <!-- department -->
          <div class="ui-g-6 p-0 pr-4 mt-30">
            <div class="">
              <app-input id="driver-update-department" [value]="driver.department" name="department" theme="primary"
                placeholder="Department" [fontSize]="14" [maxLength]="25"
                (appChange)="handleChange('department', $event)" [isInvalid]="error.department"
                [errorMessage]="error.department" [floatingLabel]="true"></app-input>
            </div>
          </div>
          <!-- Address -->
          <div class="ui-g-6 p-0 pr-4 mt-30">
            <div class="">
              <app-input id="driver-update-address" [value]="driver?.address?.addLine1" name="addLine1" theme="primary"
                placeholder="Address" [fontSize]="14" [maxLength]="25"
                (appChange)="handleChange('address.addLine1', $event)" [isInvalid]="error['address.addLine1']"
                [errorMessage]="error['address.addLine1']" [floatingLabel]="true"></app-input>
            </div>
          </div>
        </div>
        <div class="ui-g-12 p-0">
          <!-- city -->
          <div class="ui-g-6 p-0 pr-4 mt-30">
            <div class="">
              <app-input id="customer-update-zip1" name="zip" theme="primary" placeholder="Zip / Postal code"
                [floatingLabel]="true" [fontSize]="14" [maxLength]="7" [isInvalid]="error?.zip"
                [errorMessage]="error?.zip" [value]="driver?.address?.zip"
                (appChange)="handleChange('address.zip', $event)" (appFocus)="handleFocus('zip')"
                (appBlur)="handleBlur('address')">
              </app-input>

            </div>
          </div>
          <!-- state -->
          <div class="ui-g-6 p-0 pr-4 mt-30">
            <div class="">
              <app-auto-complete id="customer-update-city1" listId="customer-update-city1-list"
                placeholder="Search city" label="City" theme="primary" field="city" [floatingLabel]="true"
                [fontSize]="14" [suggestions]="addressCityResults"
                [value]="renderCityName(driver?.address?.city,driver?.address?.stateCode)"
                (appSelect)="onAddressCitySelect($event, 'address')"
                (appCompletedMethod)="onAddressCitySearch($event, 'primary')" (appClear)="onAddressClear('primary')">
                <ng-template let-item appTemplate="item">
                  <div class="flex-between-center">
                    <div class="font-14">
                      {{ item.city }}, {{ item?.stateCode }}
                    </div>
                  </div>
                </ng-template>
              </app-auto-complete>

            </div>
          </div>
        </div>
        <div class="ui-g-12 p-0">
          <!-- zip-pCode -->
          <div class="ui-g-6 p-0 pr-4 mt-30">
            <div class="">

              <app-input id="driver-update-state" [value]="driver?.address?.state" name="state" theme="primary"
                placeholder="State" [fontSize]="14" [maxLength]="25" (appChange)="handleChange('address.state', $event)"
                [isInvalid]="error['address.state']" [errorMessage]="error['address.state']"
                [floatingLabel]="true"></app-input>
            </div>
          </div>
          <!-- phone-number -->
          <div class="ui-g-6 p-0 pr-4 mt-30">
            <div class="">
              <app-input id="customer-update-phone" name="phone" theme="primary" mask="(000) 000-0000"
                placeholder="Phone" [floatingLabel]="true" [fontSize]="14" [isInvalid]="error?.phone"
                [errorMessage]="error?.phone" [maxLength]="25" [value]="driver?.phone"
                (appChange)="handleChange('phone', $event)" (appFocus)="handleFocus('phone')"
                (appBlur)="handleBlur('phone')">
              </app-input>

            </div>
          </div>
        </div>
        <div class="ui-g-12 p-0">
          <!-- Email Address -->
          <div class="ui-g-6 p-0 pr-4 mt-30">
            <div class="">
              <app-input id="driver-update-email" [value]="driver?.email" name="email" theme="primary"
                placeholder="Email Address" [fontSize]="14" [maxLength]="50" (appChange)="handleChange('email', $event)"
                [isInvalid]="error.email" [errorMessage]="error.email" [floatingLabel]="true"></app-input>
            </div>
          </div>
        </div>
      </span>
    </div>

    <div class="ui-g-12 p-0 pl-4 pr-4 mt-2 pt-1 pb-4 flex-between-center">
      <div class="show-more pointer width-100p font-600" (click)="toggle()">
        <span [hidden]="isOpen"> Show More <i class="fal fa-angle-down icon mr-1"></i></span>
        <span [hidden]="!isOpen"> Show Less <i class="fal fa-angle-up icon mr-1"></i></span>
      </div>

      <button id="btn-save" class="btn btn-primary btn-submit d-flex" [disabled]="!driver.fullName || isLoading"
        (click)="driver._id ? onUpdate() : onSubmit()">
        <span class="pr-1">{{driver?._id ? 'Update':'Save' }}</span>
        <i class="mt-1 fa fa-spinner rotate" *ngIf="isLoading"></i>
      </button>
    </div>
  </div>

</div>